import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useMapViewAddLeadEnabled() {
  const MapViewAddLead = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.MapViewAddLead),
  )

  return MapViewAddLead?.enabled ?? false
}
